/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - EMOJI SELECTION: STYLES --------------- ++++++++++ */
export default theme => ({
  emojiselection: {
    '& .singleselectdropdown': {
      zIndex: 999
    },
    '& .listtable': {
      '& .tableview': {
        borderRadius: '12px'
      },
      '& td, & th': {
        borderRight: 0,
        background: '#FFFFFF',
        // height: '64px',
        '&:first-child, &:last-child': {
          width: '120px'
        },
      }
    },
    '& .switch': {
      width: '40px',
      height: '22px',
      '& .ball': {
        top: '3px',
        left: '4px' 
      },
      '&.active-true': {
        '& .ball': {
          left: '50%'
        }
      }
    },
    '& .warningicon': {
      '& path': {
        fill: '#7E92B8'
      }
    }
  }
});
